import React, { createContext, useReducer } from 'react';
import {
  IReactParentPropTypes,
  IStateConfiguration,
  IStoreContextValue,
} from './moduleTypes';
import { createInitialState } from './state';
import { createReducer } from './reducer';
import { createModules } from './modules';

const nullNoop = () => null;

export interface StateProviderPropType extends IReactParentPropTypes {
  value?: IStoreContextValue;
}

export function createStore(configuration: IStateConfiguration) {
  const initialState = createInitialState(configuration);

  const store = createContext<IStoreContextValue>({
    state: initialState,
    dispatch: () => ({}),
    authorization: null,
  });
  const { Provider } = store;

  type IModuleSpecificState = typeof initialState;

  const modules = createModules(configuration, initialState, store);
  const reducer = createReducer<IModuleSpecificState>(modules);

  const useAuthInternal = configuration.options.useAuthorization || nullNoop;

  const StateProvider = ({ children, value }: StateProviderPropType) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const authorization = useAuthInternal();

    return (
      <Provider
        value={
          value || {
            state: state as IModuleSpecificState,
            dispatch,
            authorization,
          }
        }
      >
        {children}
      </Provider>
    );
  };

  return { store, modules, StateProvider };
}
